import styled from '@emotion/styled';
import { Magnetic as Mi } from "../../styles";
export const StyledSpan = styled.span `
	font-size: ${Mi.fontSize12};
	font-weight: ${Mi.fontWeightNormal};
	color: ${Mi.fieldLabelFontColor};
	text-transform: ${Mi.labelValuePairLabelTextTransform};
	display: ${Mi.labelValuePairLabelDisplay};
	margin-bottom: ${Mi.spacer04};
	line-height: 1;
`;
export const StyledRequiredLabelContainer = styled('span', {
    shouldForwardProp: prop => prop !== 'isResolved'
}) `
	display: flex;
	background-color: ${(props) => !props.isResolved && Mi.colorGold03};
	border-width: ${Mi.baseBorderWidth};
	border-style: ${Mi.baseBorderStyle};
	border-color: ${(props) => !props.isResolved ? Mi.colorOrange : Mi.buttonTransparentBorderColor};
	border-radius: ${Mi.baseBorderRadius};
	margin-right: ${Mi.requiredIndicatorMarginRight};
	margin-bottom: ${Mi.spacer04};
	width: ${Mi.requiredIndicatorWidth};
	height: ${Mi.requiredIndicatorHeight};
`;
export const StyledRequiredLabelIndicator = styled('span') `
	font-size: ${Mi.fontSize14};
	font-weight: ${Mi.fontWeightSemibold};
	color: ${Mi.fieldLabelFontColor};
	padding-left: 2px;
	padding-top: 3px;
	margin-top: ${Mi.labelValuePairValueMarginTop};
	width: min-content;
`;
export const StyledPrimaryValueDiv = styled.div `
	font-size: ${Mi.labelValuePairValueFontSize};
	color: ${Mi.labelValuePairValueFontColor};
`;
export const StyledSecondaryValueDiv = styled.div `
	font-size: ${Mi.fontSize12};
	color: ${Mi.baseFontColor};
`;
export const StyledPrimaryValueIcon = styled.span `
	padding-right: ${Mi.spacer04};
`;
//# sourceMappingURL=style.js.map